import { useAppConfiguration, useGraphqlMutation } from '@mews-commander/data-access';
import { graphql } from '@mews-commander/guest-profile';

const DeclineMatchMutation = graphql(`
    mutation declineMatchResult($guest1Id: UUID!, $guest2Id: UUID!) {
        declineMatch(guest1Id: $guest1Id, guest2Id: $guest2Id) {
            success
        }
    }
`);

interface MutationOptions {
    onSuccess?: () => void;
    onError?: () => void;
}

export const useDeclineMatch = (options: MutationOptions) => {
    const { guestProfileApiUrl } = useAppConfiguration();
    return useGraphqlMutation(
        guestProfileApiUrl,
        {
            document: DeclineMatchMutation,
        },
        options
    );
};
